import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Button, Input, Row, Col, Label, Tooltip } from 'reactstrap';
import { Trash } from 'react-feather';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import cogoToast from 'cogo-toast';
import { AiFillInfoCircle } from 'react-icons/ai';

const Form2 = ({ questions, setQuestions, handleSubmit, isUpdate }) => {
  const [ttop, setttop] = useState(false);

  const handleQuestionChange = (index, field, value) => {
    const updated = [...questions];
    updated[index][field] = value;
    setQuestions(updated);
  };

  const addQuestion = () => {
    if (questions?.length >= 6) {
      cogoToast.error('Users are allowed to add a maximum of 6 questions per quiz.');
      return;
    }
    setQuestions([
      ...questions,
      {
        question: '',
        options: ['', '', '', ''],
        correctIndex: 0,
      },
    ]);
  };

  const deleteQuestion = index => {
    const updated = [...questions];
    updated.splice(index, 1);
    setQuestions(updated);
  };

  const deleteOption = (qIndex, oIndex) => {
    const updated = [...questions];
    updated[qIndex].options[oIndex] = '';
    setQuestions(updated);
  };

  return (
    <Card>
      <CardHeader className="fw-medium mb-4 d-flex justify-content-between align-items-center fs-16">
        {/* <div>
          <strong>Create Questionnaire</strong>
          <i className="ms-2 bi bi-info-circle-fill text-muted" />
        </div> */}

        <div>
          <Tooltip
            placement="top"
            isOpen={ttop}
            target="TooltipTop"
            toggle={() => {
              setttop(!ttop);
            }}
          >
            Please Note: Maximum 6 questions can be added or minimum 1 questions can be added
          </Tooltip>
          Create Questionnaire{' '}
          <span id="TooltipTop" className="cursor-pointer">
            <AiFillInfoCircle />
          </span>
        </div>

        <Button color="success" onClick={addQuestion}>
          + Add Row
        </Button>
      </CardHeader>

      {questions?.map((q, i) => (
        <div key={i} className="p-4 mb-4 rounded" style={{ borderBottom: i !== questions.length - 1 && '1px solid #e0e0e0' }}>
          <Label className="fw-semibold">Create Question {i + 1}</Label>
          <Row className="mb-3">
            <Col md={6}>
              <CKEditor
                editor={ClassicEditor}
                data={q.question || ''}
                onChange={(event, editor) => {
                  const data = editor?.getData();
                  handleQuestionChange(i, 'question', data);
                }}
              />
            </Col>

            <Col md={6}>
              <Row>
                {q.options.map((opt, j) => (
                  <Col md={6} key={j} className="mb-3">
                    <div className="option-box d-flex align-items-center justify-content-between">
                      <Input
                        type="radio"
                        name={`correct-${i}`}
                        checked={q.correctIndex === j}
                        onChange={() => handleQuestionChange(i, 'correctIndex', j)}
                        className="custom-radio me-2 cursor-pointer"
                      />

                      <Input
                        type="text"
                        placeholder="Enter Value"
                        value={opt}
                        onChange={e => {
                          const updatedOptions = [...q.options];
                          updatedOptions[j] = e.target.value;
                          handleQuestionChange(i, 'options', updatedOptions);
                        }}
                        className="custom-input"
                        invalid={!opt}
                        style={{ border: 'none !important', height: '45px' }}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
          {questions.length > 1 && !q?.questionId && (
            <div className="text-end">
              <Button color="danger" onClick={() => deleteQuestion(i)}>
                <Trash size={16} className="me-1" />
              </Button>
            </div>
          )}
        </div>
      ))}

      <div className="d-flex justify-content-end mt-4">
        <Button color="success" style={{ fontSize: '17px', padding: '6px 40px', borderRadius: '8px', margin: '30px' }} onClick={handleSubmit}>
          {isUpdate ? 'Update' : 'Save'}
        </Button>
      </div>
    </Card>
  );
};

export default Form2;
